





































































































































































































































































































































































































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    matchedIndexIdInArray,
    splitStringByCharacter,
    getIndexFromList,
    placeHolderArrayFields
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Combobox,
    Breadcrums,
    PlusEyeButtons,
    CloseConfirmationModal
} from '../../core/components';
import Input from '../../core/components/Input.vue';
import Checkbox from '../../core/components/Checkbox.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import CreateParameter from './CreateParameter.vue';
import DynamicFields from './DynamicFields.vue';

import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { NormsServices } from '../api/NormsServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        DynamicFields,
        Breadcrums,
        CreateParameter,
        CloseConfirmationModal,
        Input,
        Checkbox,
        SimpleTable
    }
})
export default class CreateFrame extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    //vars
    @Prop() visible: boolean;
    @Prop() framesTypes: any;
    @Prop() allProtocols: any;
    @Prop() protocolSelected: any;
    @Prop({ default: {} }) fieldToPatch: object;
    @Prop() categories: any;
    @Prop() editing: boolean;
    @Prop() editingEcu: boolean;
    @Prop() visibleFromList: boolean;
    @Prop() visibleFromDatabase: boolean;
    visibleCloseConfirmationModal: boolean = false;
    paramsToRemove: any = [];
    editParameter: boolean = false;
    ecuCount: number = 0;
    visibleModalCreateParameter: boolean = false;
    pendingRequest: boolean = false;
    errorResponse: any = {};
    modalTitle: string = '';
    submitButtonText: string = '';
    dynamicFields: any = [];
    breadcrumsItems: any = [];
    step: any = 1;
    titleStep1: string = 'Crear Frame';
    titleStep2: string = 'Previsualizar Frame';
    visibleModalCreateFrame: boolean = false;
    protocolOptions: any = [];
    placeholderArrayFields: string = placeHolderArrayFields;

    //frame
    frameDescription: string = '';
    protocolSel: any | null = null;
    typeSelected: any | null = null;
    caegorySelected: any | null = null;
    broadcasted: any | null = null;
    updatedonetime: any | null = null;
    updatedPeriodically: any | null = null;
    updatedOnRequest: any | null = null;
    period: any = 0;
    validitytime: any = 0;
    frameLength: any = 0;
    maxLength: any = 0;
    paramToPatch: object = {};
    paramsSelected: any = [];
    loadingParams: boolean = false;
    searchParams: string = '';
    headersParamsList: object = [
        {
            text: 'Descripción',
            align: 'left',
            value: 'variable_definition.description'
        },
        {
            text: 'Slot',
            align: 'left',
            value: 'slot.description'
        },
        {
            text: 'Unidad',
            align: 'center',
            value: 'unit.description'
        },
        {
            text: 'Alertas',
            align: 'center',
            value: 'pending'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions_db',
            width: '120'
        }
    ];
    booleanOptions: any = [
        {
            value: true,
            description: 'true'
        },
        {
            value: false,
            description: 'false'
        }
    ];
    wakeuppatternidletime: number = 0;
    wakeuppatternhightime: number = 0;
    wakeuppatternlowtime: number = 0;
    multiframesnposition: number = 0;
    multiframeinitdataposition: number = 0;
    filterlength: number = 0;
    filterposition: number = 0;
    filterpositionString: string = '';
    pgnnumber: number = 0;
    priority: number = 0;
    priorityString: string = '';
    ecunumberposition: number = 0;
    header: number = 0;
    headerfilter: number = 0;
    frameArray: string = '';
    datafilter: string = '';
    datamask: string = '';
    headermask: string = '';
    // framedataarray: string = '{}';
    filterdataarray: string = '';
    filtermaskarray: string = '';
    multiframeresponse: boolean | null = null;
    standardrequest: boolean | null = null;
    frameArrayIsValid: boolean = true;
    existsEmptyFields: number = 0;
    deletedParam: boolean = false;
    //protocols ids
    //ISO14230 > 0
    //ISO15765 > 1
    //J1939 > 2
    //J1587 > 4
    //SERIAL > 5
    //CAN > 6
    fields: any = [
        {
            label: 'StandardRequest',
            key: 'standardrequest',
            type: 'select',
            options: this.booleanOptions,
            trackBy: 'value',
            value: 'description',
            noOptionsText: '',
            protocol_id: [2],
            required: true,
            model: this.standardrequest
        },
        {
            label: 'PGN',
            key: 'pgnnumber',
            type: 'number',
            protocol_id: [2],
            required: true,
            model: this.pgnnumber
        },
        {
            label: 'TxPriority',
            key: 'priority',
            type: 'number',
            protocol_id: [4],
            required: true,
            model: this.priority
        },
        {
            label: 'TxPriority',
            key: 'priority',
            type: 'number',
            protocol_id: [2],
            required: true,
            model: this.priorityString
        },
        {
            label: 'MF.Response',
            key: 'multiframeresponse',
            type: 'select',
            options: this.booleanOptions,
            trackBy: 'value',
            value: 'description',
            noOptionsText: '',
            protocol_id: [0],
            required: true,
            model: this.multiframeresponse
        },
        {
            label: 'MF.SN.Position',
            key: 'multiframesnposition',
            type: 'number',
            protocol_id: [0],
            required: true,
            model: this.multiframesnposition
        },
        {
            label: 'MF.InitDataPosition',
            key: 'multiframeinitdataposition',
            type: 'number',
            protocol_id: [0],
            required: true,
            model: this.multiframeinitdataposition
        },
        {
            label: 'RxFilterData',
            key: 'filterdataarray',
            type: 'text',
            placeholder: this.placeholderArrayFields,
            maxLength: 50,
            protocol_id: [0, 1, 2, 4, 5, 6],
            required: true,
            model: this.filterdataarray,
            compare: 'filtermaskarray'
        },
        {
            label: 'RxFilterMask',
            key: 'filtermaskarray',
            placeholder: this.placeholderArrayFields,
            type: 'text',
            maxLength: 50,
            protocol_id: [0, 1, 2, 4, 5, 6],
            required: true,
            model: this.filtermaskarray,
            compare: 'filterdataarray'
        },
        {
            label: 'RxFilterPosition',
            key: 'filterposition',
            type: 'number',
            protocol_id: [0, 1, 4, 5, 6],
            required: true,
            model: this.filterposition
        },
        {
            label: 'RxFilterPosition',
            key: 'filterposition',
            type: 'number',
            protocol_id: [2],
            required: true,
            model: this.filterpositionString
        },
        // {
        //     label: '',
        //     key: 'framedataarray',
        //     type: 'text',
        //     placeholder: 'Descripción',
        //     maxLength: 50,
        //     protocol_id: [2],
        //     required: true,
        //     model: this.framedataarray
        // },
        {
            label: 'TxHeader',
            key: 'header',
            type: 'number',
            protocol_id: [6],
            required: true,
            model: this.header
        },
        {
            label: 'RxHeaderFilter',
            key: 'headerfilter',
            type: 'text',
            protocol_id: [6],
            required: true,
            model: this.headerfilter
        },
        {
            label: 'RxHeaderMask',
            key: 'headermask',
            type: 'text',
            placeholder: 'Descripción',
            maxLength: 50,
            protocol_id: [6],
            required: true,
            model: this.headermask
        },
        {
            label: 'EcuNumberPosition',
            key: 'ecunumberposition',
            type: 'number',
            protocol_id: [4],
            required: true,
            model: this.ecunumberposition
        }
    ];

    parametersList: any = [
        // {
        //     "descripcion": "Contador de Ciclos de Encendido",
        //     "unidad": {
        //         "id": 9,
        //         "descripcion": "Cuentas"
        //     },
        //     "tipo": null,
        //     "publica": true,
        //     "tracking": true,
        //     "alarma": true,
        //     "valor_minimo": null,
        //     "valor_maximo": null,
        //     "frame": 6,
        //     "starting_bit_delimiter": 1,
        //     "starting_byte": 6,
        //     "slot": {
        //         "id": 9,
        //         "descripcion": "UShort Big 16 {0,1}"
        //     },
        //     "variabledefinition": {
        //         "id": 67,
        //         "description": "Contador de Ciclos de Encendido"
        //     }
        // }
    ];

    variableDefOptions: any = [];
    slotOptions: any = [];
    unityOptions: any = [];
    dynamicFieldsAreValid: boolean = true;
    seeMoreFields: boolean = false;

    updatedParamsSelected(rows){
        this.paramsSelected = rows;
    }

    //methods
    mounted() {
        this.visibleModalCreateFrame = this.visible;
        this.handleListenKey(true);
        this.updateProtocolOptions();
        this.getOptionsCreateParameterModal();
        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_CLOSE_CHILDREN_COMPONENTS, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_FRAMES_DIALOG_CLOSE_CHILDREN_COMPONENTS, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_VISIBLE, () => {
            this.closeModal();
        });

        if (this.editing) {
            this.loadPatchData();

            this.modalTitle = 'Modificar Frame - <b> ' + this.frameDescription + '</b>';
            this.submitButtonText = 'Modificar Frame';
        } else {
            this.modalTitle = 'Crear Frame';
            this.submitButtonText = 'Crear Frame';

            if (Object.keys(this.fieldToPatch).length > 0) {
                this.loadPatchData();
            }
        }
    }

    updateFrameDescription(value){
        this.frameDescription = value;
    }
    updateValidityTime(value){
        this.validitytime = value;
    }
    updateFrameArray(value){
        this.frameArray = value;
    }
    updateSearchParams(value){
        this.searchParams = value;
    }

    getFilterLength(model) {
        if(model == null){
            return model
        }else{
            let splitted = splitStringByCharacter(model, ',');
            let inputLength = splitted.length;
            return inputLength;
        }
    }

    validateHexa(max_num, input_value) {
        let splitted = splitStringByCharacter(input_value, ',');
        let inputLength = splitted.length;
        if (input_value !== '{}' && inputLength > 1 && input_value !== null && input_value.indexOf(',') == -1) {
            this.frameArrayIsValid = false;
            return 'Los valores se separan por coma';
        } else if (inputLength > max_num) {
            this.frameArrayIsValid = false;
            return 'Máximo ' + max_num + ' caracteres';
        } else {
            this.frameArrayIsValid = true;
            return true;
        }
    }

    updateProtocolOptions() {
        if (this.protocolSelected !== null) {
            this.protocolOptions = [this.protocolSelected];
        } else {
            this.protocolOptions = this.allProtocols;
        }
    }

    get enableSeeMoreFieldsButton(){
        return this.protocolSelected && this.protocolSelected['value'] === 'J1939'
    }

    get shouldShowFrameArray() {
        const isScannerProtocolSelected = this.protocolSelected && this.protocolSelected.value === 'Scanner';
        const isIso15ProtocolSelected = this.protocolSelected && this.protocolSelected.value === 'ISO15765';

        return this.seeMoreFields || isScannerProtocolSelected || isIso15ProtocolSelected;
    }

    getIndexId(list, value){
        return getIndexFromList(list, 'id', value);
    }

    getOptionsCreateParameterModal() {
        let self = this;
        //get variable definition data
        NormsServices.getVariableDefinitionList()
            .then(response => {
                self.variableDefOptions = response;
            })
            .catch(error => {});

        //get slot list
        NormsServices.getSlotList()
            .then(response => {
                self.slotOptions = response;
            })
            .catch(error => {});

        //get unidad list
        NormsServices.getUnidadList()
            .then(response => {
                let indexUnityEmpty = self.getIndexId(response, 1);
                response[indexUnityEmpty] = {
                    id: response[indexUnityEmpty]['id'],
                    description: ' - '
                };
                self.unityOptions = response;
            })
            .catch(error => {});
    }

    get categorySelectedIsDtc() {
        let catSelected = this.caegorySelected ? Number(this.caegorySelected['id']) : null;
        if (catSelected !== null) {
            if (catSelected == 1 || catSelected == 2 || catSelected == 3) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    get disableCreateParameter() {
        if (this.categorySelectedIsDtc) {
            return true;
        } else {
            return false;
        }
    }

    dynamicFieldsValidation(value) {
        this.dynamicFieldsAreValid = value;
    }

    modifyParam(param) {
        if (param['existPreviously']) {
            this.deleteKeysFromItem(param, ['deleted', 'pending', 'modified', 'added']);
            this.deletedParam = false;
        }
        this.paramToPatch = param;
        this.editParameter = true;
        this.visibilityModalCreateParameter(true);
    }

    loadPatchData() {
        this.ecuCount = this.fieldToPatch['ecu_count'];
        //load category
        let catIndex = this.getIndexId(this.categories, this.fieldToPatch['category']);
        this.updateCategorySelected(this.categories[catIndex]);

        //load type
        if (this.fieldToPatch['type'] !== null) {
            let typeIndex = matchedIndexIdInArray(this.framesTypes, this.fieldToPatch['type'].toString());

            if (typeIndex !== -1) {
                this.updateTypeSelected(this.framesTypes[typeIndex]);
            } else {
                this.updateTypeSelected(null);
            }
        }

        //load broadcasted
        this.updateBroadcastedSelected({
            value: this.fieldToPatch['broadcasted'],
            description: this.fieldToPatch['broadcasted'].toString()
        });

        //load UpdatedOneTime
        this.updateOneTimeSelected({
            value: this.fieldToPatch['updatedonetime'],
            description: this.fieldToPatch['updatedonetime'].toString()
        });

        //load updatedperiodically
        this.updatedPeriodicallySelected({
            value: this.fieldToPatch['updatedperiodically'],
            description: this.fieldToPatch['updatedperiodically'].toString()
        });

        //load UpdatedOnRequest
        this.updatedOnRequestSelected({
            value: this.fieldToPatch['updatedonrequest'],
            description: this.fieldToPatch['updatedonrequest'].toString()
        });

        // this.period = this.fieldToPatch['period'];
        this.validitytime = this.fieldToPatch['validitytime'];
        this.frameArray = this.fieldToPatch['framearray'];

        //enable or disable checkbox j1939
        if (this.fieldToPatch['protocol_type'] == 2) {
            this.seeMoreFields = false;
            this.moreFieldsAction(false);

            setTimeout(() => {
                let fieldsByProtocol = this.getFieldsByProtocolId(this.fields, 2);
                let filteredDynamicFields = fieldsByProtocol.filter(
                    item => item['key'] !== 'standardrequest' && item['key'] !== 'pgnnumber'
                );
                for (let i = 0; i < filteredDynamicFields.length; i++) {
                    const field = filteredDynamicFields[i];

                    if (field['type'] === 'number' && field['model'] !== 0) {
                        this.seeMoreFields = true;
                        this.moreFieldsAction(true);
                    } else if (field['type'] === 'text') {
                        if (
                            field['model'] !== '' && 
                            field['model'] !== '{}' && field['model'] !== '{}') {
                            this.seeMoreFields = true;
                            this.moreFieldsAction(true);
                        }
                    }
                }
            }, 0);
        }

        for (let index = 0; index < this.fields.length; index++) {
            let formField = this.fields[index];

            let fieldsToPatchKeys = Object.keys(this.fieldToPatch);

            this.frameDescription = this.fieldToPatch['description'];
            let paramsList = this.fieldToPatch['parameter_list'];

            for (let c = 0; c < paramsList.length; c++) {
                const param = paramsList[c];
                this.$set(param, 'existPreviously', true);
                if (param['unit']['id'] == 1) {
                    paramsList[c]['unit']['description'] = ' - ';
                }
            }

            this.parametersList = paramsList;

            for (let b = 0; b < fieldsToPatchKeys.length; b++) {
                const field = fieldsToPatchKeys[b];

                if (formField['key'] === field) {
                    if (formField['type'] === 'select') {
                        formField['model'] = {
                            value: this.fieldToPatch[field],
                            description: this.fieldToPatch[field].toString()
                        };
                    } else {
                        formField['model'] = this.fieldToPatch[field];
                    }
                }
            }
        }

        this.editParameterFromUrl()
    }

    editParameterFromUrl() {
        let paramID = this.$route.params.pid;
        if (paramID) {
            let paramIdInTable = this.parametersList.findIndex(item => item['id'] === Number(paramID));
            if (paramIdInTable !== -1) {
                this.modifyParam(this.parametersList[paramIdInTable]);
            }
        }
    }

    get frameHasActiveEcus() {
        if (this.ecuCount !== 0) {
            return true;
        } else {
            return false;
        }
    }

    updateFormFields() {
        if (this.protocolSelected !== null) {
            if (this.protocolSelected['id'] === '2') {
                this.seeMoreFields = true;
            }
            this.setDynamicFieldsByProtocolSelected();
        } else {
            this.showAllDynamicFields();
        }
    }

    setDynamicFieldsByProtocolSelected() {
        this.dynamicFields = this.getFieldsByProtocolId(this.fields, Number(this.protocolSelected['id']));
    }

    showAllDynamicFields() {
        this.dynamicFields = this.fields;
    }

    getFieldsByProtocolId(array, protocol_id) {
        let protocolId = Number(protocol_id);
        return array.filter(item => item['protocol_id'].indexOf(protocolId) !== -1);
    }

    get checkIfFormIsValid() {
        if (this.frameDescription === '') {
            return false;
        }
        if (this.protocolSelected == null) {
            return false;
        }
        if (this.typeSelected == null) {
            return false;
        }
        if (this.caegorySelected == null) {
            return false;
        }
        if (this.broadcasted == null) {
            return false;
        }
        if (this.updatedonetime == null) {
            return false;
        }
        if (this.updatedPeriodically == null) {
            return false;
        }
        if (this.updatedOnRequest == null) {
            return false;
        }
        if (this.validitytime === '') {
            return false;
        }

        if (!this.frameArrayIsValid) {
            return false;
        }

        if (this.existsEmptyFields > 0) {
            return false;
        }

        if (!this.dynamicFieldsAreValid) {
            return false;
        }

        return true;
    }

    updateProtocolSelected(option) {
        // this.protocolSelected = option;
        this.$emit('update-protocol-selected', option);
    }

    addNewParameter(newParam) {
        this.deletedParam = false;
        this.loadingParams = true;
        // if(this.frameHasActiveEcus){
        //     this.$set(paramsList[c], 'isSelectable', false);
        // }
        this.$set(newParam, 'existPreviously', false);
        this.$set(newParam, 'pending', true);
        this.parametersList.push(newParam);
        this.loadingParamsEffect();
    }

    updateParameter(idToUpdate, paramData) {
        this.loadingParams = true;
        let indexParamToUpdate = this.getIndexId(this.parametersList, idToUpdate);

        if (indexParamToUpdate !== -1) {
            this.$set(this.parametersList[indexParamToUpdate], 'pending', true);
            // this.$set(this.parametersList[indexParamToUpdate], 'description', paramData['description']);
            this.$set(this.parametersList[indexParamToUpdate], 'unit', paramData['unit']);
            // this.$set(this.parametersList[indexParamToUpdate], 'tipo', paramData['tipo']);
            // this.$set(this.parametersList[indexParamToUpdate], 'publica', paramData['publica']);
            // this.$set(this.parametersList[indexParamToUpdate], 'tracking', paramData['tracking']);
            // this.$set(this.parametersList[indexParamToUpdate], 'alarma', paramData['alarma']);
            // this.$set(this.parametersList[indexParamToUpdate], 'valor_minimo', paramData['valor_minimo']);
            // this.$set(this.parametersList[indexParamToUpdate], 'valor_maximo', paramData['valor_maximo']);
            this.$set(
                this.parametersList[indexParamToUpdate],
                'starting_bit_delimiter',
                paramData['starting_bit_delimiter']
            );
            this.$set(this.parametersList[indexParamToUpdate], 'starting_byte', paramData['starting_byte']);
            this.$set(this.parametersList[indexParamToUpdate], 'slot', paramData['slot']);
            this.$set(this.parametersList[indexParamToUpdate], 'variable_definition', paramData['variable_definition']);
        }
        this.loadingParamsEffect();
    }

    loadingParamsEffect() {
        let allParams = this.parametersList;
        this.parametersList = [];
        this.parametersList = allParams;

        setTimeout(() => {
            this.loadingParams = false;
        }, 200);
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    submitFrame() {
        let self = this;
        self.scrollToTopOfModal();

        this.pendingRequest = true;
        let configuration = this.getData();
        if (this.editing) {
            this.pendingLoadingDialog('Modificando Frame...')
            NormsServices.patchFrame(configuration, this.fieldToPatch['id'])
                .then(response => {
                    this.handleSuccessAction(response['data'])
                    self.pendingRequest = false;
                    self.closeModal();
                    let updatedFrame = response['data']['frame'];
                    if(self.fieldToPatch['unique_id']){
                        self.$set(updatedFrame, 'unique_id', self.fieldToPatch['unique_id']);
                    }
                    self.$set(updatedFrame, 'ecu_count', self.fieldToPatch['ecu_count']);
                    self.$set(updatedFrame, 'id', self.fieldToPatch['id']);
                    self.$emit('updated-frame', updatedFrame, self.paramsToRemove);
                })
                .catch(error => {
                    self.handleErrorAction(error, 'No se pudo modificar la frame');
                });
        } else {
            this.pendingLoadingDialog('Generando Frame...')
            NormsServices.postCreateFrame(configuration)
                .then(response => {
                    this.handleSuccessAction(response)
                    self.pendingRequest = false;
                    self.closeModal();
                    let newFrame = response['frame'];
                    newFrame['protocol'] = self.protocolSelected['value'];
                    this.$set(newFrame, 'ecu_count', 0);
                    self.$emit('add-new-frame', newFrame);
                })
                .catch(error => {
                    // console.log("error protocolo", error);
                    self.handleErrorAction(error, 'No se pudo crear la Frame');
                });
        }
    }

    addParameter() {
        this.editParameter = false;
        this.visibilityModalCreateParameter(true);
    }

    visibilityModalCreateParameter(value) {
        this.visibleModalCreateParameter = value;
    }

    getTitleRemoveParameter(item) {
        if (item['isSelectable'] == false) {
            return 'No se puede quitar porque la frame está activa en ' + this.ecuCount + ' ecus';
        } else {
            return 'Excluir parámetro';
        }
    }

    get getTitleCategoryDropdown() {
        if (this.frameHasActiveEcus) {
            return 'Esta frame está activa en ' + this.ecuCount + ' ECUs. No se puede modificar';
        } else {
            return '';
        }
    }

    get getFrameLength() {
        let splitted = splitStringByCharacter(this.frameArray, ',');
        return splitted.length;
    }

    getData() {
        let paramsList: any = [];
        let protocolId = Number(this.protocolSelected['id']);
        let data = {
            description: this.frameDescription,
            type: Number(this.typeSelected['id']),
            broadcasted: this.broadcasted['value'],
            updatedperiodically: this.updatedPeriodically['value'],
            updatedonetime: this.updatedonetime['value'],
            updatedonrequest: this.updatedOnRequest['value'],
            validitytime: this.validitytime,
            framearray: this.frameArray === '' ||   this.frameArray == null  ? '{}' : this.frameArray,
            framelength: this.getFrameLength,
            category: Number(this.caegorySelected['id']),
            protocol_type: protocolId
        };


        for (let b = 0; b < this.parametersList.length; b++) {
            const param = this.parametersList[b];
            let paramType = param['tipo'];

            if (!this.editing) {
                delete this.parametersList[b]['id'];
            } else {
                if (param['existPreviously'] == false) {
                    this.$set(param, 'id', null);
                }
            }

            let itemToPush = {
                unit: param['unit']['id'],
                frame: param['frame'],
                starting_bit_delimiter: param['starting_bit_delimiter'],
                starting_byte: param['starting_byte'],
                slot: param['slot']['id'],
                variable_definition: param && param['variable_definition'] ? param['variable_definition']['id'] : null
            };

            if (param['id']) {
                this.$set(itemToPush, 'id', param['id']);
            }

            if (!param['deleted']) {
                paramsList.push(itemToPush);
            }
        }

        this.$set(data, 'parameter_list', paramsList);
        let protocolName = this.protocolSelected['value'].toLowerCase();
        data[protocolName] = {};
        let dynamic_fields = this.getFieldsByProtocolId(this.fields, data['protocol_type']);
        if (data[protocolName] !== 'scanner') {
            let indexMaskArray = getIndexFromList(dynamic_fields, 'key', 'filtermaskarray');
            let indexDataArray = getIndexFromList(dynamic_fields, 'key', 'filterdataarray')
            let indexFilterPosition = getIndexFromList(dynamic_fields, 'key', 'filterposition')
            let indexTxPriority = getIndexFromList(dynamic_fields, 'key', 'priority')
            
            if (indexTxPriority !== -1) {
                if (dynamic_fields[indexTxPriority]['model'] === '') {
                    dynamic_fields[indexTxPriority]['model'] = null;
                }
            }
            if (indexFilterPosition !== -1) {
                if (dynamic_fields[indexFilterPosition]['model'] === '') {
                    dynamic_fields[indexFilterPosition]['model'] = null;
                }
            }
            if (indexDataArray !== -1) {
                if (dynamic_fields[indexDataArray]['model'] === '') {
                    dynamic_fields[indexDataArray]['model'] = null;
                }
            }
            if (indexMaskArray !== -1) {
                if (dynamic_fields[indexMaskArray]['model'] === '') {
                    dynamic_fields[indexMaskArray]['model'] = null;
                }
                this.$set(
                    data[protocolName],
                    'filterlength',
                    this.getFilterLength(dynamic_fields[indexMaskArray]['model'])
                );
            }
        }

        for (let i = 0; i < dynamic_fields.length; i++) {
            const field = dynamic_fields[i];
            let fieldKey = field['key'];
            if (field['type'] !== 'select') {
                this.$set(data[protocolName], fieldKey, field['model']);
            } else {
                this.$set(data[protocolName], fieldKey, field['model']['value']);
            }
        }
        return data;
    }

    @Watch('protocolSelected', { deep: true, immediate: true })
    watchProtocolSelected() {
        this.updateFormFields();
    }

    updateSeeMoreFields(value){
        this.seeMoreFields = value;
        this.checkBoxChangeByUser(value);
    }

    checkBoxChangeByUser(value) {
        if(!value){
            let indexValueDataArray = this.dynamicFields.findIndex(item => item['key'] === 'filterdataarray');
            let indexValueFilterMask = this.dynamicFields.findIndex(item => item['key'] === 'filtermaskarray');
            let indexValuePriority = this.dynamicFields.findIndex(item => item['key'] === 'priority');
            let indexValueFilterPosition = this.dynamicFields.findIndex(item => item['key'] === 'filterposition');
            
            if(indexValueDataArray !== -1){
                this.dynamicFields[indexValueDataArray]['model'] = '';
            }
            if(indexValueFilterMask !== -1){
                this.dynamicFields[indexValueFilterMask]['model'] = '';
            }
            if(indexValuePriority !== -1){
                this.dynamicFields[indexValuePriority]['model'] = '';
            }
            if(indexValueFilterPosition !== -1){
                this.dynamicFields[indexValueFilterPosition]['model'] = '';
            }
            this.updateFrameArray('')
        }
        this.moreFieldsAction(value);
    }

    @Watch('dynamicFields', { deep: true })
    watchFormFields(fields) {
        let self = this;
        let counter = 0;
        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];
            const fieldValue = fields[i]['model'];
            if (
                field['key'] !== 'filterdataarray' && 
                field['key'] !== 'filtermaskarray' &&
                field['key'] !== 'priority' &&
                field['key'] !== 'filterposition'
            ) {
                if (fieldValue == null || fieldValue === '') {
                    counter++;
                }
            }
        }
        self.existsEmptyFields = counter;
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    scrollToTopOfModal() {
        $('.dialog-frame').scrollTop(0);
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.handleListenKey(false);
        this.visibilityCloseConfirmationModal(false);
    }

    showCloseConfirmationModal() {
        this.visibilityCloseConfirmationModal(true);
    }

    visibilityCloseConfirmationModal(value) {
        this.visibleCloseConfirmationModal = value;
    }

    removeParameter(paramsToRemove) {
        for (let i = 0; i < paramsToRemove.length; i++) {
            const param = paramsToRemove[i];
            let param_id = param['id'];
            let indexParamToRemove = matchedIndexIdInArray(this.parametersList, param_id);
            if (indexParamToRemove !== -1) {
                this.parametersList.splice(indexParamToRemove, 1);
            }
        }
        this.paramsSelected = [];
    }

    //update selectors
    updateProtSelected(option) {
        this.protocolSel = option;
    }
    updateTypeSelected(option) {
        this.typeSelected = option;
    }
    updateCategorySelected(option) {
        this.caegorySelected = option;
    }
    updateBroadcastedSelected(option) {
        this.broadcasted = option;
    }
    updateOneTimeSelected(option) {
        this.updatedonetime = option;
    }
    updatedPeriodicallySelected(option) {
        this.updatedPeriodically = option;
    }
    updatedOnRequestSelected(option) {
        this.updatedOnRequest = option;
    }

    paramsTableBg(item) {
        if (item['existPreviously'] == false) {
            return 'truncate-row table-row-green';
        } else {
            if (item['pending']) {
                if (item['deleted']) {
                    return 'truncate-row table-row-warning';
                } else if (item['added']) {
                    return 'truncate-row table-row-green';
                } else {
                    return 'truncate-row table-row-white';
                }
            }
        }
    }

    getAlertText(item) {
        if (item['existPreviously'] == false) {
            if (this.editing) {
                return 'Se creará al actualizar la frame';
            } else {
                return 'Se creará junto con la frame';
            }
        } else {
            if (item['pending']) {
                if (item['deleted']) {
                    return 'Se eliminará al actualizar la Frame';
                } else if (item['added']) {
                    return 'Se creará al actualizar la Frame';
                } else {
                    return 'Se efectuará la modificación al actualizar la Frame';
                }
            }
        }
    }

    get getBreadcrumsItems() {
        if (this.visibleFromDatabase) {
            return [
                {
                    text: 'Listado de Databases',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'goToDatabaseList'
                },
                {
                    text: this.editing ? 'Modificar Frame' : 'Crear Frame',
                    disabled: false,
                    href: '',
                    active: true,
                    action: null
                }
            ];
        } else {
            if (this.visibleFromList) {
                return [
                    {
                        text: 'Listado de Frames',
                        disabled: false,
                        href: '',
                        active: false,
                        action: 'goToFramesList'
                    },
                    {
                        text: this.editing ? 'Modificar Frame' : 'Crear Frame',
                        disabled: false,
                        href: '',
                        active: true,
                        action: null
                    }
                ];
            } else {
                return [
                    {
                        text: 'Listado de ECUs',
                        disabled: false,
                        href: '',
                        active: false,
                        action: 'goToEcuList'
                    },
                    {
                        text: this.editingEcu ? 'Modificar Ecu' : 'Crear Ecu',
                        disabled: false,
                        href: '',
                        active: false,
                        action: 'back'
                    },
                    {
                        text: this.editing ? 'Modificar Frame' : 'Crear Frame',
                        disabled: false,
                        href: '',
                        active: true,
                        action: null
                    }
                ];
            }
        }
    }

    excludeParameter(item) {
        if (item['existPreviously'] == false) {
            this.paramsToRemove.push(item);
            this.removeParameter([item]);
        } else {
            this.deletedParam = true;
            this.deleteKeysFromItem(item, ['deleted', 'modified', 'added']);
            this.$set(item, 'pending', true);
            this.$set(item, 'deleted', true);
        }
    }

    deleteKeysFromItem(item, keys: string[]) {
        keys.forEach(kei => {
            if (item[kei]) {
                item[kei] = false;
                delete item[kei];
            }
        });
    }

    recoverParam(item) {
        this.deleteKeysFromItem(item, ['deleted', 'pending', 'added']);
    }

    get disabledProtocol() {
        if (this.editing || (this.protocolOptions && this.protocolOptions.length == 1)) {
            return true;
        } else {
            return false;
        }
    }

    moreFieldsAction(value) {
        let filteredFieldsByProtocol = this.getFieldsByProtocolId(this.fields, 2);
        let filteredVisibleFields;

        if (value) {
            filteredVisibleFields = filteredFieldsByProtocol;
        } else {
            filteredVisibleFields = filteredFieldsByProtocol.filter(
                item => item['key'] === 'standardrequest' || item['key'] === 'pgnnumber'
            );
        }

        this.dynamicFields = filteredVisibleFields;
    }
}
